export default __webpack_public_path__ + "static/media/darkpinup-coa-pack.4430dfd6.png";